export const aboutStyles = () => ({
    root: {
        margin: '0',
        padding: '0',
        backgroundColor: '#0B1432',
        boxSizing: 'border-box',
        minHeight: '100vh',
        width: '100%',
        color: 'white',
    },
    itemContainer: {
        marginBottom: '5%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
  });
